import styled from '@emotion/styled';
import { useLingui } from '@lingui/react/macro';
import { RestartAlt } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import classNames from 'classnames';
import { useAtom } from 'jotai';

import {
  DEFAULT_BRIGHTNESS_VALUE,
  DEFAULT_CONTRAST_VALUE,
} from '../../../../constants';
import { greyLight700 } from '../../../../theme/videa-style-tokens';
import { modelsTogglesAtom } from '../../findingSidebar/atoms';
import { ImageBrowser } from '../../multiFileViewer/findingViewer/imageBrowser/ImageBrowser';
import {
  brightnessValueAtom,
  contrastValueAtom,
} from '../../multiFileViewer/imageToolbar/atoms';
import { FindingsToggles } from '../../multiFileViewer/imageToolbar/FindingsToggles/FindingsToggles';
import { hiddenAnnotationsAtom } from '../atoms';
import { DownloadOptions } from '../patientDownloadable/DownloadOptions';

import { CasePresentationImageTracker } from './CasePresentationImageTracker';

const ToolbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 16px;
  z-index: 0;
  .toolbar-left {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-right: 1em;
    @media (max-width: 1200px) {
      margin-right: 1em;
    }
    .white {
      color: white;
    }
    .disabled {
      color: ${greyLight700} !important;
    }
    .MuiButtonBase-root {
      font-size: inherit;
      @media (max-width: 800px) {
        font-size: 0.75em;
      }
    }
  }
`;

export const CasePresentationToolbar = () => {
  const { t } = useLingui();
  const [enabledFindingTypes, setEnabledFindingTypes] =
    useAtom(modelsTogglesAtom);
  const [brightnessValue, setBrightnessValue] = useAtom(brightnessValueAtom);
  const [contrastValue, setContrastValue] = useAtom(contrastValueAtom);
  const [hiddenAnnotations, setHiddenAnnotations] = useAtom(
    hiddenAnnotationsAtom,
  );

  const isToolbarSettingsNotDefault =
    brightnessValue !== DEFAULT_BRIGHTNESS_VALUE ||
    contrastValue !== DEFAULT_CONTRAST_VALUE ||
    !!hiddenAnnotations.length;

  const resetToolbarSettings = () => {
    if (!isToolbarSettingsNotDefault) {
      return;
    }
    setBrightnessValue(DEFAULT_BRIGHTNESS_VALUE);
    setContrastValue(DEFAULT_CONTRAST_VALUE);
    setHiddenAnnotations([]);
  };

  return (
    <ToolbarContainer>
      <div className="toolbar-left">
        <IconButton
          aria-label="Reset Toolbar Settings"
          
          className={classNames([
            {
              disabled: !isToolbarSettingsNotDefault,
              white: isToolbarSettingsNotDefault,
            },
          ])}
          onClick={resetToolbarSettings}
        >
          <Tooltip title={t`Reset Image Brightness/Contrast/Hidden Findings`}>
            <RestartAlt />
          </Tooltip>
        </IconButton>
        <ImageBrowser />
        <FindingsToggles
          onSetEnabledFindingTypes={setEnabledFindingTypes}
          enabledFindingTypes={enabledFindingTypes}
        />
      </div>
      <CasePresentationImageTracker />
      <DownloadOptions />
    </ToolbarContainer>
  );
};
